module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-az-d32fc961aeb11af953ad305e53d43f3f.png";